import { ChangeEvent } from "@mcleod/components";
import { AutogenLayoutDriverHistoryReport } from "./autogen/AutogenLayoutDriverHistoryReport";

export class DriverHistoryReport extends AutogenLayoutDriverHistoryReport {
    override onLoad(): void | Promise<void> {
        this.textboxDateType.selectedItem = this.textboxDateType.items[0];
        this.textboxDriverStatus.selectedItem = this.textboxDriverStatus.items[0];
        this.textboxDriverType.selectedItem = this.textboxDriverType.items[0];
        this.textboxGroupBy.selectedItem = this.textboxGroupBy.items[0];
    }

    textboxGroupByOnChange(event: ChangeEvent){
        this.checkboxPageBreak.checked = false;
    }
}
